module.exports = __webpack_public_path__ + "img/chalet ext hiver.36926c51.jpeg";